import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { cva } from 'class-variance-authority'
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  CSSProperties,
  forwardRef,
} from 'react'

import { cn } from '@/shared/lib'

const sizeValues = {
  default: '1px',
  medium: '4px',
  large: '10px',
  xLarge: '24px',
} as const

const separatorVariants = cva('shrink-0 bg-gray-100 focus:outline-blue-900', {
  variants: {
    orientation: {
      horizontal: 'h-(--size) w-full',
      vertical: 'h-full w-(--size)',
    },
    color: {
      'light-gray': 'bg-gray-50',
      gray: 'bg-gray-100',
      black: 'bg-gray-900',
    },
  },
})

type Props = {
  size?: keyof typeof sizeValues
  color?: 'light-gray' | 'gray' | 'black'
}

const Separator = forwardRef<
  ComponentRef<typeof SeparatorPrimitive.Root>,
  ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & Props
>(
  (
    {
      className,
      orientation = 'horizontal',
      decorative = false,
      size = 'default',
      color = 'gray',
      ...props
    },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      style={{ '--size': sizeValues[size] } as CSSProperties}
      className={cn(separatorVariants({ orientation, color, className }))}
      {...props}
    />
  ),
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
